import type {SimulatorHandPoseRotations} from './HandPoseJoints';
import {SimulatorHandPose} from './HandPoses';

export const SIMULATOR_HAND_POSE_ROTATIONS: Readonly<
  Record<SimulatorHandPose, SimulatorHandPoseRotations>
> = Object.freeze({
  [SimulatorHandPose.NEUTRAL]: {
    wrist: [0, 0, 0],
    'thumb-metacarpal': [0, 0, 0],
    'thumb-phalanx-proximal': [0, 0, 0],
    'thumb-phalanx-distal': [0, 0, 0],
    'index-finger-metacarpal': [0, 0, 0],
    'index-finger-phalanx-proximal': [0, 0, 0],
    'index-finger-phalanx-intermediate': [0, 0, 0],
    'index-finger-phalanx-distal': [0, 0, 0],
    'middle-finger-metacarpal': [0, 0, 0],
    'middle-finger-phalanx-proximal': [0, 0, 0],
    'middle-finger-phalanx-intermediate': [0, 0, 0],
    'middle-finger-phalanx-distal': [0, 0, 0],
    'ring-finger-metacarpal': [0, 0, 0],
    'ring-finger-phalanx-proximal': [0, 0, 0],
    'ring-finger-phalanx-intermediate': [0, 0, 0],
    'ring-finger-phalanx-distal': [0, 0, 0],
    'pinky-finger-metacarpal': [0, 0, 0],
    'pinky-finger-phalanx-proximal': [0, 0, 0],
    'pinky-finger-phalanx-intermediate': [0, 0, 0],
    'pinky-finger-phalanx-distal': [0, 0, 0],
  },
  [SimulatorHandPose.RELAXED]: {
    wrist: [0.066528, 0.199494, 0.406252],
    'thumb-metacarpal': [0.288969, -0.421561, 0.566077],
    'thumb-phalanx-proximal': [0.314159, 0, 0],
    'thumb-phalanx-distal': [0, 0, 0],
    'index-finger-metacarpal': [0, 0, 0],
    'index-finger-phalanx-proximal': [0.436331, 0, 0],
    'index-finger-phalanx-intermediate': [0.57596, 0, 0],
    'index-finger-phalanx-distal': [0.226891, 0, 0],
    'middle-finger-metacarpal': [0, 0, 0],
    'middle-finger-phalanx-proximal': [0.157079, 0, 0],
    'middle-finger-phalanx-intermediate': [0.610866, 0, 0],
    'middle-finger-phalanx-distal': [0.2618, 0, 0],
    'ring-finger-metacarpal': [0, 0, 0],
    'ring-finger-phalanx-proximal': [0, 0, 0],
    'ring-finger-phalanx-intermediate': [0.610866, 0, 0],
    'ring-finger-phalanx-distal': [0.261799, 0, 0],
    'pinky-finger-metacarpal': [0, 0, 0],
    'pinky-finger-phalanx-proximal': [0, 0, 0],
    'pinky-finger-phalanx-intermediate': [0.506145, 0, 0],
    'pinky-finger-phalanx-distal': [0.261799, 0, 0],
  },
  [SimulatorHandPose.PINCHING]: {
    wrist: [0.066528, 0.199494, 0.406252],
    'thumb-metacarpal': [0.672677, -0.541947, 0.45959],
    'thumb-phalanx-proximal': [0.428777, -0.042223, -0.002288],
    'thumb-phalanx-distal': [-0.185089, -0.007076, -0.003675],
    'index-finger-metacarpal': [0.005858, -0.000129, 0.000663],
    'index-finger-phalanx-proximal': [0.959931, 0.11827, -0.091682],
    'index-finger-phalanx-intermediate': [0.692695, 0.000662, -0.000369],
    'index-finger-phalanx-distal': [0.033553, -0.000104, -0.000203],
    'middle-finger-metacarpal': [0.004162, 0.000012, -0.00278],
    'middle-finger-phalanx-proximal': [0.151863, 0.088683, 0.002485],
    'middle-finger-phalanx-intermediate': [0.715085, 0.000293, 0.000308],
    'middle-finger-phalanx-distal': [0.173078, -0.000105, -0.000133],
    'ring-finger-metacarpal': [0.001171, 0.000302, -0.007015],
    'ring-finger-phalanx-proximal': [-0.037672, -0.115556, 0.033333],
    'ring-finger-phalanx-intermediate': [0.690004, -0.000103, 0.000208],
    'ring-finger-phalanx-distal': [0.234816, -0.000133, 0.000076],
    'pinky-finger-metacarpal': [-0.002313, 0.000835, -0.011248],
    'pinky-finger-phalanx-proximal': [0.008876, -0.107748, 0.030917],
    'pinky-finger-phalanx-intermediate': [0.527087, -0.000118, 0.000211],
    'pinky-finger-phalanx-distal': [0.279492, 0.000126, 0.000026],
  },
  [SimulatorHandPose.FIST]: {
    wrist: [0.718906, -0.420664, 0.506276],
    'thumb-metacarpal': [0.501474, -0.295042, 0.551349],
    'thumb-phalanx-proximal': [0.457195, -0.17737, 0.299589],
    'thumb-phalanx-distal': [0.050138, 0.061422, -0.365074],
    'index-finger-metacarpal': [0.16857, 0.00471, 0],
    'index-finger-phalanx-proximal': [1.466077, 0, 0],
    'index-finger-phalanx-intermediate': [1.413682, -0.001122, 0.000132],
    'index-finger-phalanx-distal': [1.256637, -0.000368, 0],
    'middle-finger-metacarpal': [0.060684, 0.007245, 0],
    'middle-finger-phalanx-proximal': [1.186824, 0, 0],
    'middle-finger-phalanx-intermediate': [1.375812, -0.001242, 0.000057],
    'middle-finger-phalanx-distal': [1.169371, -0.000647, -0.000158],
    'ring-finger-metacarpal': [0, 0, 0],
    'ring-finger-phalanx-proximal': [1.169371, 0, 0],
    'ring-finger-phalanx-intermediate': [1.330938, 0.001089, -0.000398],
    'ring-finger-phalanx-distal': [1.343904, 0.00026, -0.000166],
    'pinky-finger-metacarpal': [-0.002309, 0, 0],
    'pinky-finger-phalanx-proximal': [1.256637, 0.000002, 0],
    'pinky-finger-phalanx-intermediate': [1.389296, 0.000234, -0.000492],
    'pinky-finger-phalanx-distal': [1.291544, 0.000307, 0.000013],
  },
  [SimulatorHandPose.THUMBS_UP]: {
    wrist: [0.704686, -0.201371, 1.791237],
    'thumb-metacarpal': [0.134051, -0.193436, 0.759515],
    'thumb-phalanx-proximal': [-0.125664, -0.029745, 0.357544],
    'thumb-phalanx-distal': [-0.08182, 0.010624, -0.369933],
    'index-finger-metacarpal': [0.156866, 0.01325, 0.103641],
    'index-finger-phalanx-proximal': [1.39272, -0.12805, 0.164079],
    'index-finger-phalanx-intermediate': [1.584616, -0.00124, 0.000347],
    'index-finger-phalanx-distal': [0.536045, -0.000439, -0.000414],
    'middle-finger-metacarpal': [0.055222, 0.011182, 0.102008],
    'middle-finger-phalanx-proximal': [1.326915, -0.138643, 0.126843],
    'middle-finger-phalanx-intermediate': [1.541392, -0.001225, 0.000167],
    'middle-finger-phalanx-distal': [0.707589, -0.000696, -0.000066],
    'ring-finger-metacarpal': [0.022297, -0.015343, 0.137564],
    'ring-finger-phalanx-proximal': [1.286056, 0.225023, 0.176957],
    'ring-finger-phalanx-intermediate': [1.562286, 0.001084, -0.000253],
    'ring-finger-phalanx-distal': [0.622574, 0.000385, 0.000122],
    'pinky-finger-metacarpal': [-0.007839, -0.022999, 0.194136],
    'pinky-finger-phalanx-proximal': [1.220849, 0.266958, 0.111277],
    'pinky-finger-phalanx-intermediate': [1.790949, 0.000178, -0.000611],
    'pinky-finger-phalanx-distal': [0.601801, 0.000321, 0.0003],
  },
  [SimulatorHandPose.POINTING]: {
    wrist: [0.596035, -0.414914, 1.043752],
    'thumb-metacarpal': [0.637297, -0.491225, 0.458936],
    'thumb-phalanx-proximal': [0.759414, -0.175775, 0.269178],
    'thumb-phalanx-distal': [0.081354, 0.073188, -0.363034],
    'index-finger-metacarpal': [0.000001, 0.003655, 0.000013],
    'index-finger-phalanx-proximal': [-0.000086, -0.000092, 0],
    'index-finger-phalanx-intermediate': [0, -0.000363, -0.001156],
    'index-finger-phalanx-distal': [0, 0.000023, -0.000357],
    'middle-finger-metacarpal': [0, 0.007851, 0],
    'middle-finger-phalanx-proximal': [0.944767, -0.158674, 0.038806],
    'middle-finger-phalanx-intermediate': [1.301244, -0.001132, -0.000083],
    'middle-finger-phalanx-distal': [0.429908, -0.000818, -0.000263],
    'ring-finger-metacarpal': [0.014748, -0.019316, 0.158147],
    'ring-finger-phalanx-proximal': [1.093878, 0.194757, 0.02078],
    'ring-finger-phalanx-intermediate': [1.298489, 0.001164, -0.00052],
    'ring-finger-phalanx-distal': [0.510774, 0.000157, -0.000034],
    'pinky-finger-metacarpal': [-0.008366, -0.028749, 0.217979],
    'pinky-finger-phalanx-proximal': [0.977895, 0.073588, -0.202452],
    'pinky-finger-phalanx-intermediate': [1.33904, 0.00018, -0.000557],
    'pinky-finger-phalanx-distal': [0.58579, 0.00031, 0.000028],
  },
  [SimulatorHandPose.ROCK]: {
    wrist: [0.011734, -0.065693, 0.297017],
    'thumb-metacarpal': [0.785398, -0.750492, 0.575959],
    'thumb-phalanx-proximal': [0.794647, -0.152901, 0.267991],
    'thumb-phalanx-distal': [-0.127808, -0.007272, -0.369855],
    'index-finger-metacarpal': [0.000008, 0.000002, 0],
    'index-finger-phalanx-proximal': [0, 0, 0],
    'index-finger-phalanx-intermediate': [0, -0.000368, -0.001003],
    'index-finger-phalanx-distal': [0, -0.00004, -0.000417],
    'middle-finger-metacarpal': [0.000012, 0, 0],
    'middle-finger-phalanx-proximal': [0.855211, -0.08504, -0.009794],
    'middle-finger-phalanx-intermediate': [1.064651, -0.001181, -0.000268],
    'middle-finger-phalanx-distal': [1.500983, 0.000001, -0.000536],
    'ring-finger-metacarpal': [0.006811, -0.000004, 0],
    'ring-finger-phalanx-proximal': [0.593412, 0.000002, 0],
    'ring-finger-phalanx-intermediate': [1.32645, 0.000966, -0.000864],
    'ring-finger-phalanx-distal': [0.977384, 0.000177, -0.000314],
    'pinky-finger-metacarpal': [-0.00368, -0.000004, 0],
    'pinky-finger-phalanx-proximal': [-0.000013, 0.008337, 0],
    'pinky-finger-phalanx-intermediate': [0, -0.00029, -0.000068],
    'pinky-finger-phalanx-distal': [0, 0.000287, -0.000171],
  },
  [SimulatorHandPose.THUMBS_DOWN]: {
    wrist: [0.640485, -1.129773, -0.862294],
    'thumb-metacarpal': [0.134043, -0.297017, 0.699054],
    'thumb-phalanx-proximal': [-0.219144, 0.085162, 0.341408],
    'thumb-phalanx-distal': [-0.182932, -0.028732, -0.368936],
    'index-finger-metacarpal': [0.179881, 0.01461, -0.081296],
    'index-finger-phalanx-proximal': [1.094576, -0.009837, 0.210567],
    'index-finger-phalanx-intermediate': [1.409529, -0.001213, 0.000183],
    'index-finger-phalanx-distal': [0.411586, -0.000133, -0.000362],
    'middle-finger-metacarpal': [0.067365, 0.01336, 0.042841],
    'middle-finger-phalanx-proximal': [1.170727, -0.076803, 0.077463],
    'middle-finger-phalanx-intermediate': [1.482675, -0.00116, 0.000134],
    'middle-finger-phalanx-distal': [0.578475, -0.000688, -0.000169],
    'ring-finger-metacarpal': [0.018267, -0.009114, 0.18615],
    'ring-finger-phalanx-proximal': [1.141257, 0.264759, 0.083493],
    'ring-finger-phalanx-intermediate': [1.504595, 0.001183, 0],
    'ring-finger-phalanx-distal': [0.52937, 0.000492, -0.000155],
    'pinky-finger-metacarpal': [0.00421, -0.021035, 0.291251],
    'pinky-finger-phalanx-proximal': [0.905139, 0.318725, -0.069524],
    'pinky-finger-phalanx-intermediate': [1.693415, 0.000318, -0.000533],
    'pinky-finger-phalanx-distal': [0.580409, 0.000258, 0.000122],
  },
  [SimulatorHandPose.VICTORY]: {
    wrist: [0.10923, 0.217352, 0.365586],
    'thumb-metacarpal': [0.907571, -0.577914, 0.414543],
    'thumb-phalanx-proximal': [0.931093, -0.18921, 0.243373],
    'thumb-phalanx-distal': [0.349066, 0.000003, -0.366582],
    'index-finger-metacarpal': [0, 0, 0],
    'index-finger-phalanx-proximal': [0, 0.000006, 0],
    'index-finger-phalanx-intermediate': [0, -0.000334, -0.000981],
    'index-finger-phalanx-distal': [0, -0.000126, -0.000478],
    'middle-finger-metacarpal': [0.000003, 0, 0],
    'middle-finger-phalanx-proximal': [0, -0.000022, 0],
    'middle-finger-phalanx-intermediate': [0, -0.000308, -0.001127],
    'middle-finger-phalanx-distal': [0, -0.000334, -0.000871],
    'ring-finger-metacarpal': [0.139626, -0.05236, 0.15708],
    'ring-finger-phalanx-proximal': [0.279253, -0.000012, 0],
    'ring-finger-phalanx-intermediate': [2.007129, 0.000761, -0.000725],
    'ring-finger-phalanx-distal': [0.663225, 0.000338, -0.000212],
    'pinky-finger-metacarpal': [0.157079, -0.087266, 0.191986],
    'pinky-finger-phalanx-proximal': [0.15708, -0.20944, 0],
    'pinky-finger-phalanx-intermediate': [2.059489, -0.000263, -0.000474],
    'pinky-finger-phalanx-distal': [0.977384, 0.000422, 0.000077],
  },
} as const);
